<template>
  <div class="head-card mb-2">
    <div class="head-card-bottom">
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-primary"
        :to="{ name: 'dashboard-campaigns-creative-overview', params: { userId: $route.params.userId, id: $route.params.id, bannerId: $route.params.bannerId } }"
        pill
        exact
      >
        {{ $t('campaigns.navigation.overview') }}
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-primary"
        :to="{ name: 'dashboard-campaigns-creative-v2', params: { userId: $route.params.userId, id: $route.params.id, bannerId: $route.params.bannerId } }"
        pill
      >
        {{ $t('campaigns.navigation.phoenix') }}
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-primary"
        :to="{ name: 'creatives-rtb-stats-overview', params: { userId: $route.params.userId, id: $route.params.id, bannerId: $route.params.bannerId } }"
        pill
      >
        {{ $t('rtb_stats.menu.rtb') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'CreativeNavigation',
  components: {
    BButton,
  },
  directives: {
    Ripple,
  },
}
</script>

<style scoped lang="scss">
.head-card-bottom {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}
</style>
